<div class="dropdown-tree-item-content"
     [class.selectable-row]="node.selectable"
     (click)="select()">
      <span class="nav-caret" *ngIf="node.children?.length" (click)="toggle($event)">
        <i aria-hidden="true" class="fa fa-light"
           [class.fa-caret-down]="node.expanded"
           [class.fa-caret-right]="!node.expanded"></i>
      </span>
  <div class="dropdown-tree-item-text m-l-xs"
       [ngClass]="{
               'selectable': node.selectable,
               'text-muted': !node.selectable
           }"
       [innerHtml]="sanitize(node.text | translate | highlight:inputValue)">
  </div>
</div>
<div class="dropdown-tree-item-children" *ngIf="node.expanded && node.children?.length">
  <gp-tree-select-node *ngFor="let node of node.children | sortByTranslations:
                        triggerSortByTranslationPipe :['text'] | async"
                       [node]="node"
                       [attr.data-hidden]="!node.visible || isFiltered(node)"
                       [selectFn]="selectFn"
                       [isFiltered]="isFiltered"
                       [triggerSortByTranslationPipe]="triggerSortByTranslationPipe"
                       (isNodeToggle)="this.isNodeToggle.emit(node)"
                       [inputValue]="inputValue">
  </gp-tree-select-node>
</div>
